// WebSocket connection for real-time updates
const PLENTY_API_URL = import.meta.env.VITE_PLENTY_API_URL || "/api/v1/plenty";

export const createPlentyWebSocket = (onMessage, onError) => {
  // Construct WebSocket URL properly for both absolute and relative URLs
  let wsUrl;

  if (
    PLENTY_API_URL.startsWith("http://") ||
    PLENTY_API_URL.startsWith("https://")
  ) {
    // Absolute URL (development/localhost)
    wsUrl = `${PLENTY_API_URL.replace(/^http/, "ws")}/articles/ws`;
  } else {
    // Relative URL (production with nginx)
    // Use current window location to build WebSocket URL
    const protocol = window.location.protocol === "https:" ? "wss:" : "ws:";
    const host = window.location.host;
    wsUrl = `${protocol}//${host}${PLENTY_API_URL}/articles/ws`;
  }

  console.log("Connecting to WebSocket:", wsUrl);

  const ws = new WebSocket(wsUrl);
  let keepAliveInterval;

  ws.onopen = (event) => {
    console.log("WebSocket connected successfully");
    // Send periodic keepalive messages
    keepAliveInterval = setInterval(() => {
      if (ws.readyState === WebSocket.OPEN) {
        ws.send(
          JSON.stringify({ type: "ping", timestamp: new Date().toISOString() }),
        );
        console.log("Sent keepalive ping");
      }
    }, 30000); // Send ping every 30 seconds
  };

  ws.onmessage = (event) => {
    try {
      const data = JSON.parse(event.data);

      // Log pong responses
      if (data.type === "pong") {
        console.log("Received pong response");
      }

      if (onMessage) {
        onMessage(data);
      }
    } catch (error) {
      console.error("Error parsing WebSocket message:", error);
    }
  };

  ws.onerror = (error) => {
    console.error("WebSocket error:", error);
    if (onError) {
      onError(error);
    }
  };

  ws.onclose = (event) => {
    console.log("WebSocket closed:", event.code, event.reason);
    // Clear the keepalive interval when connection closes
    if (keepAliveInterval) {
      clearInterval(keepAliveInterval);
    }
  };

  return ws;
};
